export default __webpack_public_path__ + "static/media/apple-icon-60x60.7887a868.png";